partner
<template>
  <Content title="企业资质">
    <div class="d-flex flex-wrap">
      <div v-for="index in 8" :key="index" class="qualification-item">
        <img class="lazyload" :data-src="`/images/pages/gp/qualification-${index}.png`" />
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'DesktopQualification',
  components: { Content },
}
</script>

<style lang="scss" scoped>
.qualification-item {
  width: 270px;
  height: 290px;
  padding: 16px 8px;
  margin: 16px;
  flex-basis: 20%;
  background-color: #f1f1f1;
}

.qualification-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
